import { render, staticRenderFns } from "./ProjectReportsAccountingParentBar.component.vue?vue&type=template&id=a1fb174a&scoped=true"
import script from "./ProjectReportsAccountingParentBar.component.vue?vue&type=script&lang=js"
export * from "./ProjectReportsAccountingParentBar.component.vue?vue&type=script&lang=js"
import style0 from "./ProjectReportsAccountingParentBar.component.vue?vue&type=style&index=0&id=a1fb174a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fb174a",
  null
  
)

export default component.exports